import { useCheckPermissions } from '@/shared';
import { SaveRadioBase } from '../../shared/components';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateRadioBasePageInterface { }

const CreateRadioBasePage: React.FC<CreateRadioBasePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_radiobase)

  return <SaveRadioBase
    enableUploadFile={true}
    titlePage="Crear radio base" />;
};

export default CreateRadioBasePage;
